import React, { memo, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import styles from './ImgRank.module.less';
import SoftCardGameImg from '../../components/SoftCardGameImg/SoftCardGameImg';
import ASoftCardGameImg from '../../components/ASoftCardGameImg/ASoftCardGameImg';
import { sortSoftsByLocalSoftInit } from '../../utils/utils';
import { useInView } from 'react-intersection-observer';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectLocalSoftsInit = createSelector(
  state => state.native,
  native => native.installedSoftInit,
);

export default memo(({ data, logInfo }) => {
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);
  const localSoftsInit = useSelector(selectLocalSoftsInit);

  const [showName, setShowName] = useState('');
  const [code, setCode] = useState('');
  const [showSofts, setShowSofts] = useState([]);
  const [contentClass, setContentClass] = useState(styles.content_column3);

  const LOG_ACTION_SOURCE = {
    c_menu: `${logInfo.tag}_Group`,
    c_change: `${logInfo.tag}_Group_Change`,
    source: `${logInfo.tag}_Group`,
  };

  const [ref, inView] = useInView({
    threshold: 1,
  });

  useEffect(() => {
    if (inView && logInfo && logInfo.changView) {
      logInfo.changView({
        pageCardId: data && data.dataList && data.dataList[0] && data.dataList[0].pageCardContentId,
        pageCardTitle: data && data.title,
        rankCode: data && data.dataList && data.dataList[0] && data.dataList[0].code,
        cardType: data && data.cardType,
      });
    }
  }, [inView]);

  // 筛洗数据，去除运营配置数据错误情况
  useEffect(() => {
    if (data && data.dataList && data.dataList.length > 0 && data.dataList[0].apps) {
      const pageSize = parseInt(data.row, 10) * 3;
      const showSoftArr = sortSoftsByLocalSoftInit(data.dataList[0].apps || [], localSoftsInit);
      // 可展示应用个数小于配置的需要展示应用数，则只显示一行即为3个
      if (showSoftArr.length < pageSize) {
        setShowSofts(showSoftArr.slice(0, 3));
      } else {
        setShowSofts(showSoftArr.slice(0, pageSize));
      }
      setShowName(data.dataList[0].name);
      setCode(data.dataList[0].code);
    }

    if (data && data.column && data.row) {
      if (data.column === '3') {
        setContentClass(styles.content_column3);
      }
    }
  }, [dispatch, localSoftsInit]);

  return showSofts && showSofts.length > 0 ? (
    <div className={styles.card} ref={ref}>
      <div className={styles.card_header}>
        <div className={styles.card_header_title}>{showName}</div>
      </div>
      <div className={contentClass}>
        {showSofts.map((item, j) =>
          item.androidType === '1' ? (
            <ASoftCardGameImg
              soft={item}
              logInfo={{
                ...logInfo,
                source: `${LOG_ACTION_SOURCE.source}||${code}`,
                source_p: logInfoData.source_p,
                source_pp: logInfoData.source_pp,
              }}
              key={j}
            />
          ) : (
            <SoftCardGameImg
              soft={item}
              logInfo={{
                ...logInfo,
                source: `${LOG_ACTION_SOURCE.source}||${code}`,
                source_p: logInfoData.source_p,
                source_pp: logInfoData.source_pp,
              }}
              key={j}
            />
          ),
        )}
      </div>
    </div>
  ) : (
    ''
  );
});
